/* Change this file to get your personal Portfolio */

// To change portfolio colors globally go to the  _globalColor.scss file

import emoji from "react-easy-emoji";
import splashAnimation from "./assets/lottie/splashAnimation"; // Rename to your file name for custom animation

// Splash Screen

const splashScreen = {
  enabled: true, // set false to disable splash screen
  animation: splashAnimation,
  duration: 1000 // Set animation duration as per your animation
};

// Summary And Greeting Section

const illustration = {
  animated: true // Set to false to use static SVG
};

const greeting = {
  username: "guptaachin",
  title: "Hi, I'm Achin",
  workTitle: emoji(
    "Staff Engineer 👨‍💻 experienced in building 🔧 resilient, scalable systems and thoughtfully applying agentic AI 🤖"
  ),
  funTitle: emoji("Loves exploring 🌍, trying new foods 🍲, gaming 🎮."),
  futureTitle: emoji("Let's create the future! 🚀"),
  resumeLink:
    "https://drive.google.com/file/d/1mRCp35BRk6ZYh1U_rTLnKhx7GnGmLdkz/view?usp=sharing", // Set to empty to hide the button
  displayGreeting: true // Set false to hide this section, defaults to true
};

// Social Media Links

const socialMediaLinks = {
  github: "https://github.com/guptaachin",
  linkedin: "https://www.linkedin.com/in/guptaachin/",
  hashnode: "https://guptaachin.hashnode.dev/",
  gmail: "guptaachin01@gmail.com",
  youtube: "https://www.youtube.com/channel/UCJ9bFPzRJuEk_EuoOq6ZQRg",
  // Instagram, Twitter and Kaggle are also supported in the links!
  // To customize icons and social links, tweak src/components/SocialMedia
  display: true // Set true to display this section, defaults to false
};

// Skills Section

const skillsSection = {
  title: "What I do",
  subTitle:
    "Staff Engineer passionate about building scalable systems and intelligent AI solutions.",
  skills: [
    emoji(
      "🏗️ Design and architect scalable observability platforms processing 100M+ data points daily"
    ),
    emoji(
      "🔧 Build robust CI/CD pipelines and microservices infrastructure on cloud platforms (AWS, GCP)"
    ),
    emoji(
      "📊 Develop comprehensive data pipelines for metrics collection from Kubernetes and virtual machines"
    ),
    emoji(
      "🤖 Create intelligent agentic AI systems using LangGraph for autonomous decision-making and workflow orchestration"
    ),
    emoji(
      "👥 Lead cross-functional teams and mentor engineers to drive technical excellence and innovation"
    )
  ],

  /* Make Sure to include correct Font Awesome Classname to view your icon
https://fontawesome.com/icons?d=gallery */

  softwareSkills: [
    {
      skillName: "Python",
      fontAwesomeClassname: "fab fa-python"
    },
    {
      skillName: "Docker",
      fontAwesomeClassname: "fab fa-docker"
    },
    {
      skillName: "Kubernetes",
      fontAwesomeClassname: "fa-solid fa-dharmachakra"
    },
    {
      skillName: "GCP",
      fontAwesomeClassname: "fa-solid fa-cloud"
    },
    {
      skillName: "AWS",
      fontAwesomeClassname: "fab fa-aws"
    },
    {
      skillName: "Observability",
      fontAwesomeClassname: "fa-solid fa-magnifying-glass"
    },
    {
      skillName: "LangChain",
      fontAwesomeClassname: "fa-solid fa-link"
    },
    {
      skillName: "LangSmith",
      fontAwesomeClassname: "fa-solid fa-hammer"
    },
    {
      skillName: "LangGraph",
      fontAwesomeClassname: "fa-solid fa-robot"
    },
    {
      skillName: "Agentic AI",
      fontAwesomeClassname: "fa-solid fa-brain"
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Education Section

const educationInfo = {
  display: true, // Set false to hide this section, defaults to true
  schools: [
    {
      schoolName: "University of Southern California",
      logo: require("./assets/images/USCLogo.png"),
      subHeader: "Master of Science in Computer Science",
      duration: "June 2017 - May 2019",
      desc: "Participated in the Computer Vision research and published 1 paper."
      // descBullets: [""]
    },
    {
      schoolName: "Panjab University",
      logo: require("./assets/images/PULogo.png"),
      subHeader: "Bachelor of Science in Computer Science",
      duration: "June 2009 - May 2013",
      desc: "Graduated with honors as top of the class"
      // descBullets: [""]
    }
  ]
};

// Your top 3 proficient stacks/tech experience
const techStack = {
  viewSkillBars: true, //Set it to true to show Proficiency Section
  experience: [
    {
      Stack: "Observability",
      progressPercentage: "90%"
    },
    {
      Stack: "Cloud and Microservices",
      progressPercentage: "85%"
    },
    {
      Stack: "Backend/Design/Develop", //Insert stack or technology you have experience in
      progressPercentage: "80%" //Insert relative proficiency in percentage
    },
    {
      Stack: "Agentic AI & LangGraph",
      progressPercentage: "75%"
    },
    {
      Stack: "CI/CD",
      progressPercentage: "75%"
    }
  ],
  displayCodersrank: false // Set true to display codersrank badges section need to changes your username in src/containers/skillProgress/skillProgress.js:17:62, defaults to false
};

// Work experience section
// Intuit mark is loaded from /public so <img src> gets a real URL. (CRA's SVG rule
// turns require("*.svg") into a React component, which breaks img src.)

const workExperiences = {
  display: true,
  currentRoleFlat: {
    display: true,
    role: "Staff Software Engineer",
    company: "Intuit",
    companylogo: `${(process.env.PUBLIC_URL || "").replace(/\/$/, "")}/IntuitLogo.svg`,
    date: "April 2026 – Present",
    desc: "",
    descBullets: [
    ]
  },
  experience: [
    {
      role: "Staff Engineer",
      company: "Netskope",
      companylogo: require("./assets/images/NetskopeLogo.png"),
      date: "June 2019 – April 2026",
      desc: "Leading observability platform architecture serving 3000+ engineers across global engineering teams",
      descBullets: [
        "Architected and deployed scalable metrics backend processing 100M+ data points daily",
        "Built robust CI/CD pipelines reducing deployment time by 70% and increasing reliability",
        "Led cross-functional initiatives improving system observability and reducing incident resolution time by 50%",
        "Mentored junior engineers and drove technical excellence across multiple product teams"
      ]
    },
    {
      role: "Engineering Development Group Intern",
      company: "Mathworks",
      companylogo: require("./assets/images/mwksLogo2.png"),
      date: "Jan 2019 – May 2019",
      desc: "Prototyped AI-powered features for Simulink Test using machine learning and time series analysis",
      descBullets: [
        "Developed pattern detection algorithms for automated test case generation",
        "Implemented ML models for anomaly detection in simulation workflows",
        "Created proof-of-concept integrations that influenced product roadmap decisions"
      ]
    },
    {
      role: "Research Assistant",
      company: "ISI-USC",
      companylogo: require("./assets/images/ISILogo.png"),
      date: "Feb 2018 – Sep 2018",
      desc: "Computer Vision research focusing on deep neural networks for scene text detection",
      descBullets: [
        "Published research paper accepted at ICDAR 2019 on script language effects in text detection",
        "Developed novel CNN architectures improving text detection accuracy across multiple languages",
        "Collaborated with international research teams on multilingual text processing challenges"
      ]
    },
    {
      role: "Associate Software Engineer",
      company: "Chicmic",
      companylogo: require("./assets/images/chicmicLogo.jpeg"),
      date: "Jan 2013 – July 2014",
      desc: "Full-stack mobile developer creating viral applications with 6M+ combined downloads",
      descBullets: [
        "Developed 'Clap to Find' reaching 5M+ downloads with 4.2★ rating and Google Play Store featuring",
        "Built 'Speak to Find' achieving 1M+ downloads using innovative voice recognition technology",
        "Led end-to-end development from concept to deployment, including UI/UX design and ASO",
        "Received Achievement Award for exceptional contribution to company growth and innovation"
      ]
    }
  ]
};

/* Your Open Source Section to View Your Github Pinned Projects
To know how to get github key look at readme.md */

const openSource = {
  showGithubProfile: "false", // Set true or false to show Contact profile using Github, defaults to true
  display: false // Set false to hide this section, defaults to true
};

// Some big projects you have worked on

const bigProjects = {
  title: "Featured Projects",
  subtitle: "INNOVATIVE AGENTIC AI AND BACKEND SYSTEMS I'VE BUILT",
  projects: [
    {
      image: require("./assets/images/saayaHealthLogo.webp"),
      projectName: "LangGraph Agentic Workflows",
      projectDesc:
        "Built intelligent multi-agent systems using LangGraph for autonomous decision-making, complex workflow orchestration, and dynamic task planning with state management.",
      footerLink: [
        {
          name: "View on GitHub",
          url: "https://github.com/guptaachin"
        }
      ]
    },
    {
      image: require("./assets/images/nextuLogo.webp"),
      projectName: "AI Agent Orchestration Platform",
      projectDesc:
        "Developed a scalable platform for deploying and managing agentic AI systems with real-time monitoring, workflow visualization, and performance analytics.",
      footerLink: [
        {
          name: "View Project",
          url: "https://github.com/guptaachin"
        }
      ]
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Achievement Section
// Include certificates, talks etc

const achievementSection = {
  title: emoji("Achievements And Certifications 🏆 "),
  subtitle:
    "Achievements, Certifications, Award Letters and Some Cool Stuff that I have done !",

  achievementsCards: [
    {
      title: "TED AI San Francisco Hackathon Winner - Google Gemini",
      subtitle:
        "Placed second. Took home $2000 in cash and $15000 in Google Gemini credits",
      image: require("./assets/images/ted.png"),
      imageAlt: "TED AI San Francisco Hackathon Logo",
      footerLink: [
        {
          name: "View Achievement",
          url: "https://tedai-sanfrancisco.ted.com/hackathon/"
        },
        {
          name: "Project Demo",
          url: "https://youtu.be/GEluAcd8dCw"
        }
      ]
    },
    {
      title: "Buildathon 2025 Awardee",
      subtitle:
        "Special Award in Graph Thinking - Recognized for innovative approach to graph-based problem solving and reasoning patterns.",
      image: require("./assets/images/buildathon-logo.png"),
      imageAlt: "Buildathon.AI Logo",
      footerLink: [
        {
          name: "View Achievement",
          url: "https://www.linkedin.com/posts/aifund_what-an-amazing-day-of-building-we-welcomed-activity-7363266895174639617-bnEw?utm_source=share&utm_medium=member_desktop&rcm=ACoAAB9WcQ8BseTPDo7yLbQMF8a0X35Rh1O__1c"
        }
      ]
    },
    {
      title: "OCPJP SE6",
      subtitle: "Oracle Certified Professional, Java SE 6 Prgrammer",
      image: require("./assets/images/OCPJPLOGO.bmp"),
      imageAlt: "Google Code-In Logo",
      footerLink: [
        {
          name: "Certification",
          url: "https://drive.google.com/file/d/0B7IAk_Y1lWQHZ3I5U3l6cVFQM1E/view?usp=drive_link&resourcekey=0-r20eZF7igk5iIrrf-Fu-bg"
        }
      ]
    },
    {
      title: "IBM Certified Academic Associate",
      subtitle: "DB2 9 Database and Application Fundamentals",
      image: require("./assets/images/DB2LOGO.bmp"),
      imageAlt: "Google Assistant Action Logo",
      footerLink: [
        {
          name: "Certification",
          url: "https://drive.google.com/file/d/0B7IAk_Y1lWQHVlp1UjViR2dpNEE/view?usp=drive_link&resourcekey=0-6jmn4_RtJjlKC4RaLw8ORA"
        }
      ]
    },
    {
      title: "Achievement Award - Chicmic",
      subtitle:
        "Awarded for taking the full responsibility towards the work assigned and towards the growth of the company. He is one of the few whose actions are in alignment with company's growth.",
      image: require("./assets/images/chicmicLogo.jpeg"),
      imageAlt: "Google Assistant Action Logo",
      footerLink: [
        {
          name: "Award Certficate",
          url: "https://drive.google.com/file/d/1hl3WqF2STbB2D3qUFEAIYvlpiY8s6dOd/view?usp=sharing"
        }
      ]
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Blogs Section
const blogSection = {
  title: "Blogs",
  subtitle: "",
  displayMediumBlogs: "true", // Set true to display fetched medium blogs instead of hardcoded ones
  blogs: [
    {
      url: "url1-loading...",
      title: "title1-loading...",
      brief: "brief1-loading..."
    },
    {
      url: "url2-loading",
      title: "title2-loading...",
      brief: "brief2-loading..."
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Talks Sections

const talkSection = {
  title: "TALKS",
  subtitle: emoji(
    "I LOVE TO SHARE MY LIMITED KNOWLEDGE AND GET A SPEAKER BADGE 😅"
  ),

  talks: [
    {
      title: "Build Actions For Google Assistant",
      subtitle: "Codelab at GDG DevFest Karachi 2019",
      slides_url: "https://bit.ly/guptaachin-slides",
      event_url: "https://www.facebook.com/events/2339906106275053/"
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Podcast Section

const podcastSection = {
  title: emoji("Podcast 🎙️"),
  subtitle: "I LOVE TO TALK ABOUT MYSELF AND TECHNOLOGY",

  // Please Provide with Your Podcast embeded Link
  podcast: [
    "https://anchor.fm/codevcast/embed/episodes/DevStory---Saad-Pasta-from-Karachi--Pakistan-e9givv/a-a15itvo"
  ],
  display: false // Set false to hide this section, defaults to true
};

const contactInfo = {
  title: emoji("Contact Me ☎️"),
  subtitle:
    "Discuss a project or just want to say hi? My Inbox is open for all.",
  // number: "+1-310-846-7289",
  email_address: "guptaachin01@gmail.com"
};

// Twitter Section

const twitterDetails = {
  userName: "twitter", //Replace "twitter" with your twitter username without @
  display: false // Set true to display this section, defaults to false
};

const isHireable = true; // Set false if you are not looking for a job. Also isHireable will be display as Open for opportunities: Yes/No in the GitHub footer

export {
  illustration,
  greeting,
  socialMediaLinks,
  splashScreen,
  skillsSection,
  educationInfo,
  techStack,
  workExperiences,
  openSource,
  bigProjects,
  achievementSection,
  blogSection,
  talkSection,
  podcastSection,
  contactInfo,
  twitterDetails,
  isHireable
};
